<template>
  <footer class="footer">
    <nav>
      <div class="menu">
        <!-- <router-link to="/about">about</router-link> | -->
        <router-link to="/imprint">imprint</router-link> |
        <router-link to="/privacy">privacy</router-link>
        <!-- <router-link to="/contact">contact</router-link> | -->
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: "FooterNavigation",
};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 50px !important;
  opacity: 0.7;
}
nav {
  padding: 30px;
  background-color: #d3d3d4;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 200;
  height: 100%;
}
nav a {
  font-weight: normal;
  font-size: 0.8rem;
  padding: 0 10px;
  color: #fff;
  text-decoration: none;
}
nav a:hover {
  color: #999;
}
nav a.router-link-exact-active {
  color: #000101;
}
.menu {
  margin-right: 100px;
  position: absolute;
  left: 45%;
  margin-top: -10px;
}
</style>
